import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home'
import Home from '../views/newPage/home.vue'
import industryPage from '../views/industryPage'
import platformPage from '../views/platformPage'
import CounterUpPage from '../views/CounterUpPage'
import PortfolioPage from '../views/PortfolioPage'
import TabPage from '../views/TabPage'
import ErrorPage from '../views/404'
import SuccessDetail from '../views/home-pages/SuccessDetail'
import CallUs from '../views/home-pages/CallUs'
import ServiceSupport from '../views/ServiceSupport.vue'
import AboutUs from '../views/AboutUs.vue'
import Information from "../views/Information.vue"
import InformationDetails from "../views/InformationDetails.vue"
import JoinPartners from '../views/JoinPartners.vue'
import SuccessCases from '../views/SuccessCases.vue'
import dataAgentPage from '../views/dataAgentPage.vue'
import EcoAIBigData from '../views/EcoAIBigData.vue'
import IndustryPractice from '../views/newPage/IndustryPractice.vue'
import ecopPage from '../views/newPage/ecopPage.vue'
import aiPage from '../views/newPage/aiPage.vue'
import productSolution from '../views/newPage/productSolution.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
        meta: {
            title: '博信诚，为企业和公共组织提供智能服务的领导厂商',
        },
    },
    {
        path: '/home',
        name: 'Home',
        component: Home,
        meta: {
            title: '博信诚，为企业和公共组织提供智能服务的领导厂商',
        },
    },
    {
        path: '/industry/:type',
        name: 'industry',
        component: industryPage,
        meta: {
            title: '行业解决方案',
        },
    },
    {
        path: '/platform',
        name: 'platform',
        component: platformPage,
        meta: {
            title: 'ECOP平台',
        },
    },
    {
        path: '/counter/:type',
        name: 'Counter',
        component: CounterUpPage,
        meta: {
            title: '集团企业云EECLOUD',
        },
    },
    {
        path: '/dataAgent/:type',
        name: 'dataAgentPage',
        component: dataAgentPage,
        meta: {
            title: '元生AI与数据平台',
        },
    },
    {
        path: '/portfolio/:type',
        name: 'Portfolio',
        component: PortfolioPage,
        meta: {
            title: '成长型企业云ESCLOUD',
        },
    },
    {
        path: '/tab',
        name: 'Tab',
        component: TabPage,
        meta: {
            title: '智能技术RPA',
        },
    },
    {
        path: '/error',
        name: 'Error',
        component: ErrorPage,
        meta: {
            title: '404 || Doob Business and Consulting Bootstrap5 Template',
        },
    },
    {
        path: '/success-detail/:type',
        name: 'SuccessDetail',
        component: SuccessDetail,
        meta: {
            title: '成功案例详情',
        },
    },
    {
        path: '/call-us',
        name: 'CallUs',
        component: CallUs,
        meta: {
            title: '联系我们',
        },
    },
    {
        path: '/service-support',
        name: 'ServiceSupport',
        component: ServiceSupport,
        meta: {
            title: '服务与支持',
        },
    },
    {
        path: '/about-us',
        name: 'AboutUs',
        component: AboutUs,
        meta: {
            title: '关于我们',
        },
    },
    {
        path: '/join-partners',
        name: 'JoinPartners',
        component: JoinPartners,
        meta: {
            title: '加入生态伙伴',
        },
    },
    {
        path: '/information',
        name: 'Information',
        component: Information,
        meta: {
            title: '最新资讯',
        },
    },
    {
        path: '/information-details/:type',
        name: 'InformationDetails',
        component: InformationDetails,
        meta: {
            title: '最新资讯详情',
        },
    },
    {
        path: '/success-cases',
        name: 'SuccessCases',
        component: SuccessCases,
        meta: {
            title: '成功案例故事',
        },
    },{
		path: '/eco-aibigdata',
		name: 'EcoAIBigData',
		component: EcoAIBigData,
		meta: {
            title: '数据平台',
        },
    },
    {
        path: '/industry-practice/:type?',
        name: 'IndustryPractice',
        component: IndustryPractice,
        meta: {
            title: '行业实践',
        },
    },{
		path: '/ecop-page',
		name: 'ecopPage',
		component: ecopPage,
		meta: {
            title: '智慧创新平台ECOP',
        },
    },{
		path: '/ai-page',
		name: 'aiPage',
		component: aiPage,
		meta: {
            title: '元生AI平台',
        },
    },{
		path: '/product-solution/:type',
		name: 'productSolution',
		component: productSolution,
		meta: {
            title: '产品解决方案',
        },
    }
]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
	document.querySelector('body').classList.add('active-light-mode')
    document.title = to.meta.title;
    next();
    window.scrollTo(0, 0)
});

export default router
